import { required, minLength } from 'vuelidate/lib/validators'

const formData = {
  number: {
    size: 12,
    name: 'number',
    label: 'Número do cartão',
    mask: ['#### #### #### ###', '#### #### #### ####'],
    placeholder: '0000 0000 0000 0000',
    value: false
  },
  holderName: {
    size: 12,
    type: 'text',
    name: 'holderName',
    label: 'Nome impresso no cartão',
    placeholder: '(exatamente como está no cartão)',
    value: ''
  },
  expirationDate: {
    size: 8,
    type: 'text',
    name: 'expirationDate',
    label: 'Data de vencimento',
    mask: '##/##',
    placeholder: 'MM/AA',
    value: null
  },
  cvv: {
    size: 4,
    type: 'text',
    name: 'cvv',
    label: 'CVV',
    mask: '###',
    placeholder: '000',
    value: null
  }
}

const validations = {}
for (let requiredField in formData) {
  formData[requiredField].classes = ['cardPayment']
  formData[requiredField].required = true
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}
validations.number.value = {
  required,
  minLength: minLength(19)
}
validations.expirationDate.value = {
  required,
  validDate (v) {
    if (!v) {
      return true
    }
    const split = v.split('/')
    if (split.length > 1) {
      if (parseInt(split[0]) > 12) {
        return false
      }
      if (split[1].length === 2) {
        if (parseInt(split[1]) < parseInt(this.$moment(new Date()).format('YY'))) {
          return false
        } else {
          return true
        }
      }
    }
    return false
  }
}
validations.cvv.value = {
  required,
  minLength: minLength(3)
}
export {formData, validations}
